// removed by extract-text-webpack-plugin
module.exports = {"financialTab":"financialTab__1ydKo","loaderWrapper":"loaderWrapper__2m5b5","switch":"switch__N2ogT","switchLabel":"switchLabel__UEx5x","switchLabeloff":"switchLabeloff__1hIOg","switchLabelon":"switchLabelon__VY3Zy","switchInput":"switchInput__3Ivs1","switchSelection":"switchSelection__2vPq7","buttonsWrapper":"buttonsWrapper__2g9YJ","buttons":"buttons__2vN43","yearWrapper":"yearWrapper__1OhZm","pageSizeModal":"pageSizeModal__3jyVz","dropDownWrapper":"dropDownWrapper__8HKdF"};


//////////////////
// WEBPACK FOOTER
// ./components/sankey/component/style.scss
// module id = fuiZ
// module chunks = 0 1